export enum CATEGORIES {
  BINDING_VIEW_ACTION = 'view_action_types',
  BINDING_VIEW_EVENTS_ACTION = 'view_event_types',
  BINDING_FORM_ACTION = 'form_action_types',
  BINDING_FORM_EVENTS_ACTION = 'form_event_types',
  BINDING_WINDOW_ACTION = 'window_action_types',
  BINDING_WINDOW_EVENTS_ACTION = 'window_event_types',
  BINDING_EVENTS_ACTION_CONTEXT_MENU = 'view_context_menu_event_types',
  BINDING_EVENTS_ACTION_TOOLTIP = 'view_tooltip_event_types',
  BINDING_VIEW = 'view_row_binding_type',
  BINDING_TYPES_VIEW = 'view_row_binding_value_type',
  BINDING_COLUMN = 'view_column_value_binding_type',
  BINDING_TYPES_COLUMN = 'view_column_value_type',
  BINDING_RENDER_FIELD = 'form_field_rendering',
  BINDING_FIELD = 'form_field_value_types',
  BINDING_TYPES_FIELD = 'form_field_value_bindings_types',
  BINDING_RESOURCE_ACTION = 'gantt_action_resource_types',
  BINDING_EVENTS_RESOURCE_ACTION = 'gantt_event_resource_types',
  BINDING_TIMELINE_ACTION = 'gantt_action_timeline_types',
  BINDING_EVENTS_TIMELINE_ACTION = 'gantt_event_timeline_types',
  BINDING_TIME_TABLE_OBJECT_X_ACTION = 'timetable_object_x_action_types',
  BINDING_TIME_TABLE_OBJECT_Y_ACTION = 'timetable_object_y_action_types',
  BINDING_TIME_TABLE_OBJECT_X_EVENTS_ACTION = 'timetable_object_x_event_types',
  BINDING_TIME_TABLE_OBJECT_Y_EVENTS_ACTION = 'timetable_object_y_event_types',
  BINDING_TIME_TABLE_OBJECT_Y_CONTEXT_MENU_EVENT_ACTION = 'timetable_object_x_context_menu_event_types',
  BINDING_TIME_TABLE_ACTION = 'timeline_action_types',
  BINDING_TIME_TABLE_EVENTS_ACTION = 'timeline_event_types',
  BINDING_CONTEXT_MENU_POINT_ACTION = 'context_menu_point_action_types',
  BINDING_CONTEXT_MENU_POINT_EVENTS_ACTION = 'context_menu_point_event_types',
  BINDING_TIME_TABLE_OBJECT_Y_EVENTS_ACTION_TOOLTIP = 'timetable_object_y_tooltip_event_types',
  BINDING_TIME_TABLE_OBJECT_X_EVENTS_ACTION_TOOLTIP = 'timetable_object_x_tooltip_event_types',
  BINDING_TOOLTIP_ACTION = 'tooltip_action_types',
  BINDING_TOOLTIP_EVENTS_ACTIONS = 'tooltip_event_types',
}
